import { Component } from "react";
import { Link } from "react-router-dom";
import LayoutPublico from "../../componentes/Comunes/Layout/LayoutPublico";

class AccesoDenegado extends Component {
  state = {};

  render() {
    return (
      <LayoutPublico>
        <h1 className="h1 text-gray-900">Acceso Denegado</h1>
        <p className="lead text-gray-800">
          No tiene permisos para acceder a esta página o recurso.
        </p>
        <p>Contacte a un administrador para obtener permisos.</p>
        <button
          className="btn btn-primary btn-icon-split text-center mr-2"
          onClick={this.props.history.goBack}
        >
          <span className="icon text-white-50">
            <i className="fas fa-arrow-alt-circle-left"></i>
          </span>
          <span className="text">Regresar</span>
        </button>

        <Link to="/" className="button-link">
          <button className="btn btn-primary btn-icon-split text-center">
            <span className="icon text-white-50">
              <i className="fas fa-home"></i>
            </span>
            <span className="text">Página Principal</span>
          </button>
        </Link>
      </LayoutPublico>
    );
  }
}

export default AccesoDenegado;
